import "./ExperienceScreen.css";

export default function ExperienceScreen({ items }) {
  return (
    <section className="section" id="experience">
      <div className="sectionHeader">
        <div className="sectionNum">03.</div>
        <div className="sectionTitle">Experience</div>
      </div>

      <div className="timeline">
        {items.map((it) => (
          <div key={it.title + it.range} className="role">
            <div className="roleTop">
              <div className="roleTitle">{it.title}</div>
              <div className="roleMeta">{it.range} · {it.company}</div>
            </div>
            <ul>
              {it.points.map((p) => <li key={p}>{p}</li>)}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
